// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"0b260f9a","580":"e3bc846a","637":"1195806d"}[chunkId] + ".chunk.js";
};